// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1s-q";
export var animationRelative = "_1s-p";
export var backdropBlur = "_1s-0";
export var detailLabelCell = "_1s-12";
export var detailTable = "_1s-11";
export var detailValueCell = "_1s-13";
export var docIconBox = "_1s-1d";
export var docIconBoxMd = "_1s-1f";
export var docIconBoxSm = "_1s-1e";
export var docTypeRow = "_1s-16";
export var docTypeRowInner = "_1s-17";
export var dropdownMatchDatePicker = "_1s-3";
export var evidenceCardContent = "_1s-1c";
export var fileUploadSpin = "_1s-j";
export var gorgiasOpenButton = "_1s-15 _1s-d";
export var gorgiasTicketCard = "_1s-14";
export var heroModalFooterButton = "_1s-18";
export var hiddenContainer = "_1s-o";
export var iconPrimary = "_1s-1g";
export var iconSecondary = "_1s-1h";
export var iconTertiary = "_1s-1i";
export var integrationCard = "_1s-1";
export var integrationLogoBox = "_1s-2";
export var mainColumnSticky = "_1s-1b";
export var maxWidthContainer = "_1s-19";
export var modalContentBody = "_1s-a";
export var modalHeaderImage = "_1s-5";
export var modalImageLabel = "_1s-7";
export var modalImageOverlay = "_1s-6";
export var modalImageSubtitle = "_1s-9";
export var modalImageTitle = "_1s-8";
export var modalImageWrapper = "_1s-4";
export var modalStickyFooter = "_1s-b";
export var removeButton = "_1s-e";
export var sidebarColumn = "_1s-1a";
export var spinner = "_1s-i";
export var timelineLine = "_1s-y";
export var timelineLineBlack = "_1s-10 _1s-y";
export var timelineLineGray = "_1s-z _1s-y";
export var timelineLineHeight = "_1s-x";
export var tlDotActivate = "_1s-u";
export var tlDotActivateAnim = "_1s-t";
export var tlDotHide = "_1s-s";
export var tlDotHideAnim = "_1s-r";
export var tlLineActivate = "_1s-w";
export var tlLineActivateAnim = "_1s-v";
export var uploadHint = "_1s-n";
export var uploadIconBox = "_1s-k";
export var uploadLabel = "_1s-m";
export var uploadText = "_1s-l";
export var uploadZone = "_1s-f";
export var uploadZoneCursorDefault = "_1s-h";
export var uploadZoneCursorPointer = "_1s-g";
export var uploadedFileRow = "_1s-c";
export var viewButton = "_1s-d";